export default class AmplifyRouter {
  constructor({ store: { $router } }) {
    this.router = $router;
  }

  replace(param) {
    this.router.replace(param);
  }

  back() {
    this.router.back();
  }

  push(param) {
    this.router.push(param);
  }
}
